import { c as _c } from "react/compiler-runtime";
import { AiIcon } from '@newfront-insurance/nova-core';
import { motion } from 'framer-motion';
export function Greeting(t0) {
  const $ = _c(11);
  const {
    message
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 10
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      opacity: 0,
      y: 10
    };
    t4 = {
      delay: 0.5
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <motion.div initial={t1} animate={t2} exit={t3} transition={t4} className="flex items-center text-lg"><AiIcon height={20} />How can I help you today?</motion.div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0,
      y: 10
    };
    t7 = {
      opacity: 1,
      y: 0
    };
    t8 = {
      opacity: 0,
      y: 10
    };
    t9 = {
      delay: 0.6
    };
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t6 = $[5];
    t7 = $[6];
    t8 = $[7];
    t9 = $[8];
  }
  const t10 = message || "I'm Nova Assist, your AI assistant at Newfront. Ask me insurance questions, upload documents to analyze, or get help with calculations and communications.";
  let t11;
  if ($[9] !== t10) {
    t11 = <div key="overview" className="mx-auto flex size-full max-w-3xl flex-col items-center justify-center gap-3 px-8 text-center md:mt-20">{t5}<motion.div initial={t6} animate={t7} exit={t8} transition={t9} className="text-muted-foreground w-[80%] text-base">{t10}</motion.div></div>;
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  return t11;
}